export const initSliceAnimation = () => {
  if (!customElements.get('slice-animation')) {
    customElements.define('slice-animation', class SliceAnimation extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this); // Bind `this` to the onScroll function
      }

      connectedCallback() {
        this.checkVisibility(); // Initial check on load
      }

      isElementPartiallyInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
          rect.bottom > 0 &&
          rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
          rect.right > 0
        );
      }

      checkVisibility() {
        if (this.isElementPartiallyInViewport(this)) {
          this.style.animationPlayState = 'running';
          // this.querySelector('.animation-element').style.animationPlayState = 'running'

          window.removeEventListener('scroll', this.onScroll);
        } else {
          window.addEventListener('scroll', this.onScroll);
        }
      }

      onScroll() {
        this.checkVisibility(); // Check visibility on each scroll
      }
    });
  }

};
